/* 
Takes a Text input by the user and makes sure the propagated value is actually a usable float
*/
import { TextInput } from "@mantine/core";
import { useState } from "react";

export default function TextToNumberInput(props) {
  // Internally store string value, propagate the float value up
  const [thisTextValue, sethThisValue] = useState("");
  const mutateValues = (newValue) => {
    // Clean up input to only allow digits and one decimal point
    let strippedValue = newValue.replace(/[^0-9.,]/gi, "");
    strippedValue = strippedValue.replace(/,/g, ".");
    if (strippedValue.split(".").length > 2) {
      strippedValue = strippedValue.replace(/\.+$/, "");
    }
    // Sanity checks
    let asFloat = parseFloat(strippedValue);
    if (Number.isNaN(asFloat)) {
      asFloat = 0;
      strippedValue = "";
    }
    if (asFloat > props.max) {
      asFloat = props.max;
      strippedValue = asFloat.toString();
    }
    if (asFloat < props.min) {
      asFloat = props.min;
      strippedValue = asFloat.toString();
    }
    // Mutate local text value
    if (thisTextValue != strippedValue) {
      sethThisValue(strippedValue);
    }
    // Mutate parent float value
    if (asFloat != props.inputValue) {
      props.setInput(asFloat);
    }
  };

  return (
    <TextInput
      value={thisTextValue}
      placeholder={props.placeholder}
      label={props.label}
      description={props.description}
      onChange={(event) => {
        mutateValues(event.currentTarget.value);
      }}
      min={props.min}
      max={props.max}
    />
  );
}
